import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
  newPasTipMessage: string = '';
  newPasTipView: boolean = false;
  passConfig: any;
  passConfigArr: {}[];
  passConcigArrView: boolean = false;
  email: string = '';
  confirmDirty: boolean = false;
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/ModifyPas/Modules.State.ts